import AddressCell from "../address-cell";
import React from "react";
import ContactCell from "../contact-cell";

export default function Manager({ manager, className, ...props}) {
  return (
    <>
      {manager &&
        <div className={"card text-center "+className}>
          <div className="card-body">
            {manager.attachments?.length>0 && <img key={'manatt-'+manager.attachments[0].id} src={manager.attachments[0].thumbUrl} className="rounded-circle avatar-lg img-thumbnail" alt="profile-image" />}
            <h4 className="mb-0 mt-2">{manager.name}</h4>
            <p className="opacity-75 font-14">{manager.position ? manager.position : ''}</p>

            <div className="row">
              {manager?.addresses?.length>0 && <>{manager.addresses?.map((address)=>{
                  return (<div key={address.id} className="col-sm-12">
                    <AddressCell className="col-sm-12"
                                 address={address}/>
                  </div>)
              })}</>}
              {manager?.contacts?.length>0 && <>{manager.contacts?.map((contact)=>{
                return (<div key={contact.id} className="col-sm-12">
                  <ContactCell className="col-sm-12" widthClass={'w-100 text-center'}
                               contact={contact}/>
                </div>)
              })}</>}
            </div>

            <div className="text-start mt-3">
              <p className="opacity-75 font-13 mb-3">
                {manager.description}
              </p>
            </div>
          </div>
        </div>
      }
    </>
  );
}
